import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import { Button } from '@els/els-react--button';

import './sticky-table-header.scss';

function TableHeader({ getRef, headers, children, className, staticColumns, showHiddenColumns, leydenTableHeader }) {
  const headerClassName = leydenTableHeader ? 'table__head c-els-table__head' : '';
  const rowClassName = leydenTableHeader
    ? 'auto-resize table__row c-els-table__row table__row--head c-els-table__row--head'
    : 'auto-resize';
  const cellClassName = leydenTableHeader
    ? 'table__cell c-els-table__cell c-els-table__basic-cell table__cell--header c-els-table__cell--header'
    : '';

  return (
    <thead className={`${className} ${headerClassName}`.trim()} ref={getRef}>
      {children}
      <tr className={rowClassName}>
        {headers.map((header) => (
          <th
            key={header.id}
            scope="col"
            colSpan={header.colspan ? header.colspan : 1}
            className={`${cellClassName} column-${header.cssid} ${header.id === 'paureus' ? 'px-header' : ''}`.trim()}>
            {!staticColumns && (
              <Button
                data-e2e="table-header-show-hidden-columns"
                type="link"
                size="small"
                className="show-more"
                aria-label="Show hidden columns"
                onClick={showHiddenColumns}>
                {ReactTableColumnSwitcherHelper.getHiddenColumnsAmount(headers)}...
              </Button>
            )}
            <InnerHTML tag="span" html={header.title} />
          </th>
        ))}
      </tr>
    </thead>
  );
}

TableHeader.propTypes = {
  className: PropTypes.string.isRequired,
  getRef: PropTypes.object,
  headers: PropTypes.array.isRequired,
  showHiddenColumns: PropTypes.func.isRequired,
  leydenTableHeader: PropTypes.bool,
};

TableHeader.defaultProps = {
  leydenTableHeader: false,
};

export default TableHeader;
